import { StandaloneArticle } from 'base/components/Article';

export const HantStandaloneArticle: typeof StandaloneArticle = (props) => {
  if (props.hide) {
    props.hide.badge = false;
  }

  return <StandaloneArticle {...props} />;
};
